import { render, staticRenderFns } from "./Affix.vue?vue&type=template&id=eb844d7e&scoped=true&"
import script from "./Affix.vue?vue&type=script&lang=js&"
export * from "./Affix.vue?vue&type=script&lang=js&"
import style0 from "./Affix.vue?vue&type=style&index=0&id=eb844d7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb844d7e",
  null
  
)

export default component.exports